module.exports = __webpack_public_path__ + "img/quick_buy.5a56c3a0.svg";